'use strict';

import flatpickr from 'flatpickr';
import makeReservation from '../../../src/js/site/reservation&rent/makeReservation';
import loadData from '../../../src/js/site/reservation&rent/loadData';

const $ = jQuery.noConflict();

$(function() {
	const reservation = {

		init: function() {
			this.setupFlatpickr();
			loadData.init(
				['firstName', 'lastName', 'email', 'phoneNumber'],
				'.js-reservation-'
			);
			makeReservation.init();
		},

		setupFlatpickr: function() {
			const parsedFutureMoveInLimit = parseInt(window.fwsFutureMoveIn, 10);
			const futureMoveInLimit = Number.isNaN(parsedFutureMoveInLimit)
				? 5
				: Math.max(0, parsedFutureMoveInLimit);

			// eslint-disable-next-line
			const startDatePicker = flatpickr('.js-reservation-date-input', {
				enableTime: false,
				dateFormat: 'n/j/Y',
				disableMobile: true,
				// defaultDate: new Date(),
				minDate: new Date(),
				maxDate: new Date(new Date().setDate(new Date().getDate() + futureMoveInLimit)),
			});
		},
	};

	reservation.init();
});
